import { render, staticRenderFns } from "./shipmentStockLocationInfo.vue?vue&type=template&id=54c0e4fa&scoped=true"
import script from "./shipmentStockLocationInfo.vue?vue&type=script&lang=js"
export * from "./shipmentStockLocationInfo.vue?vue&type=script&lang=js"
import style0 from "./shipmentStockLocationInfo.vue?vue&type=style&index=0&id=54c0e4fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c0e4fa",
  null
  
)

export default component.exports